import styled from "styled-components";

export const RangeSC = styled.input`
    -webkit-appearance: none;
    vertical-align: middle;
    outline: none;
    border: none;
    padding: 0;
    background: none;

    &::-webkit-slider-runnable-track {
        background-color: #9d9d9d79;
        height: 6px;
        border-radius: 3px;
        border: 1px solid transparent;
    }

    &[disabled]::-webkit-slider-runnable-track {
        border: 1px solid #9d9d9d79;
        background-color: transparent;
        opacity: 0.4;
    }

    &::-moz-range-track {
        background-color: #9d9d9d79;
        height: 6px;
        border-radius: 3px;
        border: none;
    }

    &::-ms-track {
        color: transparent;
        border: none;
        background: none;
        height: 6px;
    }

    &::-ms-fill-lower {
        background-color: #9d9d9d79;
        border-radius: 3px;
    }

    &::-ms-fill-upper {
        background-color: #9d9d9d79;
        border-radius: 3px;
    }

    &::-ms-tooltip {
        display: none;
        /* display and visibility only */
    }

    &::-moz-range-thumb {
        border-radius: 20px;
        height: 18px;
        width: 18px;
        border: none;
        background: none;
        background-color: #606670;
    }

    &:active::-moz-range-thumb {
        outline: none;
    }

    &::-webkit-slider-thumb {
        -webkit-appearance: none !important;
        border-radius: 100%;
        background-color: #ff7606;
        height: 18px;
        width: 18px;
        margin-top: -7px;
    }

    &[disabled]::-webkit-slider-thumb {
        background-color: transparent;
        border: 1px solid #9d9d9d79;
    }

    &:active::-webkit-slider-thumb {
        outline: none;
    }

    &::-ms-thumb {
        border-radius: 100%;
        background-color: #ff7606;
        height: 18px;
        width: 18px;
        border: none;
    }

    &:active::-ms-thumb {
        border: none;
    }
`;

export const SliderWrapperSC = styled.div`
    display: flex;
    gap: 5px;
`;

export const SliderButtonSC = styled.button`
    background-color: #f3f4f6; /* light gray */
    border: 1px solid #d1d5db; /* subtle border */
    color: #111827; /* dark text */
    font-size: 1.25rem; /* bigger +/- symbol */
    font-weight: 500;
    border-radius: 0.5rem; /* rounded corners */
    cursor: pointer;
    transition: all 0.2s ease-in-out;

    &:hover {
        background-color: #e5e7eb; /* darker gray on hover */
    }

    &:active {
        background-color: #d1d5db; /* even darker while pressed */
        transform: scale(0.95);
    }

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
`;
